import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-patient-dialog',
    templateUrl: './patient-dialog.component.html',
    styleUrls: ['./patient-dialog.component.scss'],
    standalone: false
})
export class PatientDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PatientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSelect(selectedOptions: any): void {
    const selectedPatients = selectedOptions.map(option => option.value);
    this.dialogRef.close(selectedPatients);
  }
}
